import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class GlobalClickService {
  private renderer: Renderer2;
  private listener: (() => void) | null = null;  // Initialize with null
  private registeredComponents: any[] = [];

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
    this.initClickListener();
  }

  // Initialize body click listener only once
  private initClickListener() {
    this.listener = this.renderer.listen('document', 'click', (event: Event) => {
      this.notifyClick(event);
    });
  }

  notifyClick(event: Event, sourceComponent?: any) {
    this.registeredComponents.forEach(component => {
      if (component === sourceComponent) return;
      component.handleClickOutside(event);
    });
  }

  // Register a component for outside click handling
  registerComponent(component: any) {
    this.registeredComponents.push(component);
  }

  // Unregister a component when it's destroyed
  unregisterComponent(component: any) {
    this.registeredComponents = this.registeredComponents.filter(c => c !== component);
  }
}
